import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionDto } from "../../../autogen/bff-api";
import {
  QualificationRequirementFields,
  type QualificationFormValues,
} from "../../../common/library/fields/QualificationRequirementFields";
import { RequirementDialogHeader } from "../../../common/components/RequirementDialogHeader";

// t('Add requirement') t('Edit requirement') t('Cancel') t('Save')

export type { QualificationFormValues };

interface Props {
  isOpen: boolean;
  isSaving: boolean;
  mode: "add" | "edit";
  defaultValues?: QualificationFormValues;
  onSubmit: (values: SelectionCriterionDto) => Promise<void>;
  onClose: () => void;
}

const FORM_ID = "qualification-modal-form";

export const QualificationModal = ({ isOpen, isSaving, mode, defaultValues, onSubmit, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <RequirementDialogHeader title={t(mode === "edit" ? "Edit requirement" : "Add requirement")} />
        <ModalBody>
          <QualificationRequirementFields formId={FORM_ID} defaultValues={defaultValues} onSubmit={onSubmit} />
        </ModalBody>
        <ModalFooter borderTopWidth="1px" borderColor="smBorder">
          <Flex gap="3">
            <Button variant="outline" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button type="submit" form={FORM_ID} colorScheme="teal" isLoading={isSaving}>
              {t("Save")}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
